module.exports = __webpack_public_path__ + "img/hotnodelogo.710db5b4.svg";